// Nenhum JSON da API traz URL de arquivo: o conteúdo sai por GET /<recurso>/binary/<id>/?field=<campo>,
// autenticado, onde <id> é o do registro dono do arquivo. `binary_fields` lista só os campos preenchidos.
export const BINARY_RESOURCES = {
  internalImage: 'internals/internalimage',
  internalFile: 'internals/internalfile',
  internalInclusion: 'internals/internalinclusion',
  leavingRecord: 'internals/leavingrecord',
  receptionSocialService: 'internals/receptionsocialservice',
  receptionEducational: 'internals/receptioneducational',
  receptionPsychology: 'internals/receptionpsychology',
  reading: 'internals/reading',
  admission: 'internals/admission',
  medicalPrescription: 'internals/medical_prescription',
  internalForwarding: 'internals/internalforwarding',
  internalExamination: 'internals/internalexamination',
  internalMedicalTest: 'internals/internalmedicaltest',
  nutritionalStatus: 'internals/nutritionalstatus',
  hanseniase: 'internals/hanseniase',
  hanseniaseLesionPhoto: 'internals/hanseniase/lesion-photos',
  tuberculosisExamRequest: 'internals/tuberculosis/exam-requests',
  tuberculosisReferralRequest: 'internals/tuberculosis/referral-requests',
  tuberculosisExamArticulation: 'internals/tuberculosis/exam-articulations',
  tuberculosisClosureRecord: 'internals/tuberculosis/closure-records',
  factionRelationship: 'internals/factionrelationship',
  hearing: 'internals/hearings',
  visitorImage: 'internals/visitorimage',
  visitorFile: 'internals/visitorfile',
  training: 'users/training',
};

export const hasBinaryField = (record, field) =>
  Array.isArray(record?.binary_fields) && record.binary_fields.includes(field);

// Miniatura (WebP até 200px) só quando o registro tem; senão o campo original.
export const resolveThumbnailField = (record, field = 'picture') =>
  hasBinaryField(record, 'thumbnail') ? 'thumbnail' : field;

const normalizeImageRecords = (rawImages) => {
  const imageList = Array.isArray(rawImages) ? rawImages : [rawImages];
  return imageList.filter((image) => image && typeof image === 'object' && image.id);
};

// Foto principal: marcada como main → Perfil Frontal → Foto 3X4 → qualquer perfil/3x4 → primeira.
export const resolveMainImageRecord = (rawImages) => {
  const images = normalizeImageRecords(rawImages);
  const getTypeLabel = (image) => String(image?.type || image?.detail_type || '').toLowerCase();

  return (
    images.find((image) => image.main === true)
    || images.find((image) => image.type === 'Perfil Frontal')
    || images.find((image) => image.type === 'Foto 3X4')
    || images.find((image) => getTypeLabel(image).includes('perfil') || getTypeLabel(image).includes('3x4'))
    || images[0]
    || null
  );
};

// O interno traz a foto em `images` (objeto único no retrieve/search, lista quando enriquecido
// com internalimage) ou em `image` (listagens). Devolve o registro de internalimage (com id).
export const resolveInternalImageRecord = (internal) => {
  if (!internal) return null;
  return resolveMainImageRecord(internal.images) || resolveMainImageRecord(internal.image);
};
